<template>
	<input
		:type="type"
		v-bind="$attrs"
		:id="id"
		:value="label"
		:placeholder="label"
		@change="$emit('update:modelValue', $event.target.value)"
	/>
	<label :class="`form-check-label mx-2 ${labelClass}`" :for="id">{{
		label
	}}</label>
</template>
<script>
	export default {
		name: "BaseCheckBox",
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: null,
			},
			modelValue: {
				type: [String, Number, Array, Function, Boolean],
				default: null,
			},
			labelClass: {
				type: String,
			},
			type: {
				type: String,
				default: "checkbox",
			},
		},
	};
</script>
